import { createApp } from "vue";
import VueCookies from "vue3-cookies";
import App from "./App.vue";
import router from "./multipages";
import store from "./stores";
import vuetify from "@/plugins/vuetify";
import snotify from "vue3-snotify";
import VueCropper from "vue-cropper";

import "vuetify/lib/styles/settings/_variables.scss";

import "vuetify/dist/vuetify.min.css";
import "vue3-snotify/style";

import { fpjsPlugin } from "@fingerprintjs/fingerprintjs-pro-vue-v3";
const fingerprintAPIKey = import.meta.env.VITE_FINGERPRINT_API_KEY;

import { FabricCanvas } from "@/components/FabricWrapper/components";

// Before user leaves (closing tab or window), stop the session
if (!window) throw new Error('window is not defined');

// When app starts, initialize session tracking
store.dispatch("sessionTimer/initSession");

const app = createApp(App);
app.use(fpjsPlugin, {
  loadOptions: {
    apiKey: fingerprintAPIKey,
  },
});

app.use(vuetify);
app.use(VueCookies);
app.use(snotify);
app.use(VueCropper);

app.use(store);
app.use(router);
router.afterEach((to, from) => {
  if (window.Appcues && typeof window.Appcues.page === "function") {
    window.Appcues.page();
    console.log("Appcues is loaded.");
  } else {
    console.log("Appcues is not loaded yet.");
  }
});
app.component("FabricCanvas", FabricCanvas);
app.mount("#app");
